var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailGray500(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 3.00016C18.3332 2.0835 17.5832 1.3335 16.6665 1.3335H3.33317C2.4165 1.3335 1.6665 2.0835 1.6665 3.00016M18.3332 3.00016V13.0002C18.3332 13.9168 17.5832 14.6668 16.6665 14.6668H3.33317C2.4165 14.6668 1.6665 13.9168 1.6665 13.0002V3.00016M18.3332 3.00016L9.99984 8.8335L1.6665 3.00016",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailGray500);
export default __webpack_public_path__ + "static/media/mail-gray500.106a82629c918e952e743a575be53624.svg";
export { ForwardRef as ReactComponent };